import JwtService from "@/core/services/JwtService";

/**
 * Müşteri hesabına giriş (self-login) durumunu yönetir.
 *
 * Yöneticinin kendi token'ı `auth.origin_*` altında saklanır; müşteri
 * token'ı normal oturum anahtarlarına yazılır. Böylece "kendi hesabıma dön"
 * adımında yöneticinin oturumu yeniden giriş yapmadan geri gelir.
 */
const ORIGIN_TOKEN = 'origin_token';
const ORIGIN_TOKEN_TYPE = 'origin_tokenType';
const TARGET = 'impersonation_target';

export default {
    /**
     * Müşteri oturumuna geçer.
     *
     * @param {{token: string, type?: string, name?: string}} session
     */
    start(session) {
        // iç içe geçişte ilk (gerçek yönetici) token korunur
        if (!this.isActive()) {
            JwtService.save(ORIGIN_TOKEN, JwtService.get('token'));
            JwtService.save(ORIGIN_TOKEN_TYPE, JwtService.get('tokenType') ?? 'Bearer');
        }

        JwtService.save(TARGET, session.name ?? '');
        JwtService.save('tokenType', session.type ?? 'Bearer');
        JwtService.save('token', session.token);
    },

    /**
     * Yöneticinin kendi oturumuna döner.
     *
     * @returns {boolean} dönülecek bir oturum var mıydı
     */
    stop() {
        const token = JwtService.get(ORIGIN_TOKEN);

        if (!token) {
            return false;
        }

        JwtService.save('token', token);
        JwtService.save('tokenType', JwtService.get(ORIGIN_TOKEN_TYPE) ?? 'Bearer');

        this.clear();

        return true;
    },

    /**
     * Müşteri oturumunda mıyız?
     */
    isActive() {
        return !!JwtService.get(ORIGIN_TOKEN);
    },

    /**
     * Adına giriş yapılan müşterinin adı.
     */
    target() {
        return JwtService.get(TARGET) ?? '';
    },

    /**
     * Kayıtları temizler (çıkış yapıldığında da çağrılır).
     */
    clear() {
        JwtService.destroy(ORIGIN_TOKEN);
        JwtService.destroy(ORIGIN_TOKEN_TYPE);
        JwtService.destroy(TARGET);
    },
};
